import Client, { models, api } from "platformsh-client";

let config = {};

if (process.env.NODE_ENV === "development") {
  config = {
    base_url: "https://accounts.internal.platform.sh",
    client_id: "platform@ui.psh.dev",
    access_token: "alice",
    redirect_uri: "http://localhost:3000/",
    authorization: "https://accounts.internal.platform.sh/oauth2/authorize"
  };
} else {
  config = {
    base_url: "https://accounts.platform.sh",
    client_id: "user-widget@platform.sh"
  };
}

export const entities = models;
export const request = api;

export default (account_url, api_url, client_id, access_token) =>
  new Client({
    ...config,
    base_url: account_url || config.account_url,
    client_id: client_id || config.client_id,
    api_url,
    access_token
  });



// WEBPACK FOOTER //
// ./src/platformshClient.js